<template>

    <div v-bind:class="'dd-m-loading-box' + (type ? type : '')">
        <div class="dd-m-loading">
            <i class="dd-m-icon icon-perfume"></i>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'loading',
        props: ['type'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/loading.vue